import { Box, Typography } from "@mui/material";
import { useDerivativesCommodityMarketContext } from "../../../context/derivatives/commodity-market/DerivativesCommodityMarketContext";
import { PiChartLineDown, PiChartLineUp } from "react-icons/pi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { COLORS } from "../../../ui/Theme";

const longStyle = {
  color: COLORS.GREEN,
};

const shortStyle = {
  color: COLORS.RED,
};

const DerivativesCommodityMarketFutureContractsLinks = () => {
  const { positions } = useDerivativesCommodityMarketContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const handleClickLink = (position) => {
    const params = new URLSearchParams(searchParams);
    if (!position) return;
    else {
      params.set("position", position);
      navigate("future-contracts");
    }
    setSearchParams(params);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
        قراردادهای آتی
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "14px",
          flexWrap: { xs: "wrap", md: "nowrap" },
        }}
      >
        {positions.map((position) => (
          <button
            style={{
              ...(position.name === "خرید" ? longStyle : shortStyle),
              height: "100px",
              justifyContent: "space-between",
              padding: "0 50px",
            }}
            className="btn"
            key={position.id}
            onClick={() => handleClickLink(position.id)}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "14px" },
                  color: COLORS.GRAY,
                }}
              >
                پوزیشن
              </Typography>
              <Typography
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "20px", md: "24px" },
                }}
              >
                {position.name}
              </Typography>
            </Box>
            {position.name === "خرید" ? (
              <PiChartLineUp style={{ fontSize: "40px" }} />
            ) : (
              <PiChartLineDown style={{ fontSize: "40px" }} />
            )}
          </button>
        ))}
      </Box>
    </Box>
  );
};

export default DerivativesCommodityMarketFutureContractsLinks;
